import { createFileRoute } from '@tanstack/react-router'
import { AdminGiftCards } from '@/components/admin/marketing/AdminGiftCards'

export const Route = createFileRoute('/admin/marketing/gift-cards')({
  component: () => <AdminGiftCards />,
})
